import { Routes } from '@angular/router';
import { TrackCasesComponent } from './components/support/track-cases/track-cases.component';
import { AuthGuard } from './guards/auth.guard';
import { CommunityRedirectGuard } from './guards/community-redirect.guard';
import { CommunityComponent } from './components/community/community.component';
import { NewsDetailComponent } from './modules/news/news-detail/news-detail.component';
import { NewsListComponent } from './modules/news/news-list/news-list.component';
import { IframeComponent } from './components/support/iframe/iframe.component';
import {
    PARTNER_CONTACTS_URL, INCIDENT_URL, PORTALS_URL,
    SERVICE_REQUEST_URL, SIGNOUT_URL, TRACK_CASES_URL, TRACK_CASE_NO_URL
} from './app.constants';
import { SearchComponent } from './modules/search/components/search/search.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { LoginRedirectGuard } from './guards/login-redirect.guard';
import { SignoutGuard } from './guards/signout.guard';
import { IntuoComponent } from './components/pages/intuo/intuo.component';
import { SalesComponent } from './components/pages/sales/sales.component';
import { Resources4uComponent } from './components/pages/resources4u/resources4u.component';
import { Support4UComponent } from './components/support4u/support4u.component';
import { DownloadComponent } from './components/download/download.component';
import { MarketplaceComponent } from './components/martketplace/marketplace.component'; 
import { BillingPlatformComponent } from './components/billingplatform/billingplatform.component';

export const routes: Routes = [
    // {
    //   path: 'invoices', loadChildren: () => import('./modules/invoices/invoices.module').then(m => m.InvoicesModule)
    // },
    {
        path: 'my-solutions', 
        canActivate: [AuthGuard], 
        loadChildren: () => import('./modules/product/product.module').then(m => m.ProductModule)
    },
    {
        path: 'cloud', canActivate: [AuthGuard], loadChildren: () => import('./modules/cloud/cloud.module').then(m => m.CloudModule)
    },
    {
        path: 'services', canActivate: [AuthGuard], children: [
            {
                path: '', redirectTo: 'incident', pathMatch: 'prefix'
            },
            {
                path: 'incident', component: IframeComponent, data: { url: INCIDENT_URL, layout: 'fullWidth' }
            },
            {
                path: 'service-request', component: IframeComponent, data: { url: SERVICE_REQUEST_URL, layout: 'fullWidth' }
            },
            {
                path: 'track-cases', component: TrackCasesComponent, data: { url: TRACK_CASES_URL, layout: 'fullWidth' }
            },
            {
                path: 'track-case/:case-no', component: TrackCasesComponent, data: { url: TRACK_CASE_NO_URL, layout: 'fullWidth' }
            },
            // {
            //   path: 'knowledge-search', 
            //   component: IframeComponent, data: { url: KNOWLEDGE_SEARCH_URL, urlAppendQueryParams: true, layout: 'fullWidth' }
            // },
            {
                path: 'portals', component: IframeComponent, data: { url: PORTALS_URL, layout: 'fullWidth' }
            },
            {
                path: 'contacts', component: IframeComponent, data: { url: PARTNER_CONTACTS_URL, layout: 'fullWidth' }
            },
        ]
    },
    {
        path: 'user-management', 
        loadChildren: () => import('./modules/user-management/user-management.module').then(m => m.UserManagementModule)
    },
    {
        path: 'news', canActivate: [AuthGuard], children: [
            {
                path: 'news-item/:news-title/:news-id', component: NewsDetailComponent,
            },
            {
                path: ':page', component: NewsListComponent
            },
            {
                path: '**', component: NewsListComponent
            }
        ],
    },
    {
        path: 'my-settings', loadChildren: () => import('./modules/user-management/my-setttings.module').then(m => m.MySettingsModule)
    },
    {
        path: 'download-report-engine', canActivate: [AuthGuard], component: DownloadComponent
    },
    /* {
    path: 'my-customers', canActivate: [AuthGuard], component: MyCustomersComponent, children: [
      {
        path: 'accounts', component: AccountsComponent
        ,
      },
      {
        path: '**', redirectTo: '/my-customers/accounts'
      }
    ]
  },*/
    {
        path: 'university', canActivate: [AuthGuard], component: IntuoComponent
    },
    {
        path: 'resources', canActivate: [AuthGuard], component: Resources4uComponent
    },
    {
        path: 'salespartners', canActivate: [AuthGuard], component: SalesComponent
    },
    {
        path: 'marketplace', canActivate: [AuthGuard], component: MarketplaceComponent
    },
    {
        path: 'billingplatform', canActivate: [AuthGuard], component: BillingPlatformComponent
    },
    {
        path: 'search', canActivate: [AuthGuard], component: SearchComponent
    },
    {
        path: 'login', canActivate: [LoginRedirectGuard], component: CommunityComponent
    },
    {
        path: 'login/callback', component: AuthCallbackComponent
    },
    {
        // NGINX redirects /logout to the ServiceNow logout, which comes back here to end the Okta
        // session — see the ingress configuration in deployment.yml and AuthService.logout.
        path: SIGNOUT_URL, canActivate: [SignoutGuard], component: CommunityComponent
    },
    { path: 'home', redirectTo: '/news' },
    {
        path: '', redirectTo: '/news', pathMatch: 'full'
    // NGINX will redirect root to Community homepage which is configured in deployment.yml
    },
    {
        path: 'csm', canActivate: [AuthGuard], component: Support4UComponent 
    },
    {
        path: '**', canActivate: [CommunityRedirectGuard], component: CommunityComponent
    },

];
